import React from "react";
import { DirectorResponseActions } from "./DirectorResponseActions";
import { DirectorResponseList } from "./DirectorResponseList";
import { DirectorResponseAddDialog } from "./DirectorResponseAddDialog";
import { DirectorResponseEditDialog } from "./DirectorResponseEditDialog";
import { DirectorResponseDeleteDialog } from "./DirectorResponseDeleteDialog";
import { MaterialsManageOptions } from "./MaterialsManagement/MaterialsManageOptions";
import { DirResponseSubTypes } from "./DirResponseSubTypes";
import { useAppSelector } from "../../../../../app/hooks";
import { AdverseDrugEventOptions } from "./AdverseDrugEvent/AdverseDrugEventOptions";
import { EquipmentEventOptions } from "./Equipment/EquipmentEventOptions";
import { FallResponseActions } from "./Falls/FallResponseActions";
import { useMyProfileQuery } from "../../../../../services/profileService/profile-api";
import { PermissionChecker } from "../../../../../services/varianceService/util/PermissionChecker";
import { Stack } from "@mui/material";

function DirectorResponse() {
  const incident = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );  const { data } = useMyProfileQuery();  const canEdit = (): boolean => {
    return PermissionChecker.canEditVariance(data, incident);
  }
  return (
    <React.Fragment>
      {incident.incidentType === "ADVERSE_DRUG" && (
        <DirResponseSubTypes
          options={AdverseDrugEventOptions}
          formName="Details:"
          canEdit={canEdit()}
        />
      )}
      {incident.incidentType === "EQUIPMENT_FAILURE" && (
        <DirResponseSubTypes
          options={EquipmentEventOptions}
          formName="Details:"
          canEdit={canEdit()}
        />
      )}
      {incident.incidentType === "FALL" && <FallResponseActions canEdit={canEdit()} />}
      {incident.incidentType === "MATERIALS_MANAGEMENT" && (
        <DirResponseSubTypes
          options={MaterialsManageOptions}
          formName="Cause For Error:"
          canEdit={canEdit()}
        />
      )}
      <DirectorResponseActions canEdit={canEdit()}/>
      {canEdit() && (
        <Stack direction="row" justifyContent="flex-end" margin="20px">
          <DirectorResponseAddDialog />
        </Stack>
      )}
      <DirectorResponseList />
      <DirectorResponseEditDialog />
      <DirectorResponseDeleteDialog />
    </React.Fragment>
  );
}

export { DirectorResponse };
